import templateUrl from "emun.invoice/credit-request/credit-request-summary.htm";
export default () => ({ templateUrl });
